import { Alert, Button, ButtonGroup, Drawer, Tooltip } from "flowbite-react";
import React, { useEffect } from "react";
import { HiEye, HiInformationCircle, HiCheck, HiTrash } from "react-icons/hi";
import useDrafts from "../hooks/useDrafts";
import { DraftType } from "../types/drafts";
import { formatDate } from "../utils/formatters";

interface DraftsProps {
    onSelectDraft: (draft: DraftType) => void;
}

const Drafts = (props: DraftsProps) => {
    const [showAlert, setShowAlert] = React.useState(true);
    const [isOpen, setIsOpen] = React.useState(false);

    const { drafts, getDrafts, deleteDraft } = useDrafts();

    const handleOpenSidebar = async () => {
        await getDrafts();
        setIsOpen(true);
    }

    const handleDraftDelete = async (id: number) => {
        const confirm = window.confirm("¿Estás seguro que quieres borrar este borrador?");
        if(confirm) {
            await deleteDraft(id);
            await getDrafts();
        }
    }

    const renderAdditionalContent = () => {
        return <div className="flex">
            <Button
            type="button"
            color="warning"
            onClick={handleOpenSidebar}
            >
                <HiEye className="-ml-0.5 mr-2 h-4 w-4" />
                Ver todos
            </Button>
        </div>
    }

    const renderDrafts = () => {
        if(drafts.length === 0) return <div>No hay borradores pendientes</div>;

        // sort by date
        drafts.sort((a, b) => b.id - a.id);

        return drafts.map((draft: DraftType) => {
            if(draft.item === undefined) return <div key={draft.id}></div>

            const data = JSON.parse(draft.item);
            return <Alert 
                key={draft.id}
                color={"info"}
                className="mb-4 flex flex-col"
                additionalContent={<ButtonGroup>
                    <Button
                        color="gray"
                        onClick={() => props.onSelectDraft(draft)}
                    >
                        <Tooltip content="Usar borrador">
                            <HiCheck />
                        </Tooltip>
                    </Button>
                    <Button
                        color="failure"
                        onClick={() => handleDraftDelete(draft.id)}
                    >
                        <Tooltip content="Borrar">
                            <HiTrash />
                        </Tooltip>
                    </Button>
                </ButtonGroup>}
            >
                <p>
                    <span>{data.title.length > 0 ? data.title : "Sin título"}</span><br/>
                    <strong>Actualizado: {formatDate(draft.updatedAt)}</strong>
                </p>
            </Alert>
        })
    }

    useEffect(() => {
        (async() => {
            await getDrafts();
        })();
        // eslint-disable-next-line
    }, []);

    return <div>
        {showAlert && <Alert 
            additionalContent={renderAdditionalContent()} 
            color="warning" 
            className="mb-4" 
            icon={HiInformationCircle}
            onDismiss={() => setShowAlert(false)}
        >
            <span>Tienes borradores pendientes</span>
        </Alert>}
        <Drawer open={isOpen} onClose={() => setIsOpen(false)} position="right">
            <Drawer.Header title="Borradores" />
            <Drawer.Items>
                {isOpen && renderDrafts()}
            </Drawer.Items>
        </Drawer>
    </div>

}

export default Drafts;